import styled from 'styled-components';

interface ReadinessCardContainerProps {
  tagColor: string;
}

export const ReadinessCardContainer = styled.div<ReadinessCardContainerProps>`
  max-width: 360px;
  width: 100%;
  height: 100%;
  padding: 1.6rem 1rem 1rem;
  position: relative;
  background: ${(props) => props.theme.neutralLighter};
  border-radius: 1rem;
  box-shadow: inset 0 6px 0 0 ${({ theme }: {theme: any}) => theme.themePrimary},
    1px 1px 8px rgba(0, 0, 0, 0.2);

  cursor: pointer;
  transition: all 0.2s ease-in;

  &:hover {
    box-shadow: inset 0 10px 0 0 ${({ theme }: {theme: any}) => theme.themePrimary},
      1px 1px 8px rgba(0, 0, 0, 0.4);
  }

  .tagWrapper {
    position: absolute;
    top: 12px;
    right: 50%;
    transform: translateX(50%);
  }
`;

export const ReadinessCardContent = styled.div`
  display: grid;
  grid-template-columns: 3.75rem auto;
  column-gap: 1.25rem;

  .iconWrapper {
    grid-column: 1/2;
    grid-row: span 2;

    display: flex;
    align-items: center;
    justify-content: center;

    height: 3.75rem;
    width: 100%;

    background: ${({ theme }: {theme: any}) => theme.themePrimary};
    border-radius: 1rem;

    svg {
      width: 32px;
      height: 32px;
      object-fit: contain;
      color: #ffffff;
    }
  }

  h1 {
    font: 700 1rem/1rem 'Roboto', sans-serif;

    align-self: end;
    grid-column: 2/3;
    grid-row: 1/2;
  }

  p {
    font: 200 0.8rem/0.8rem 'Roboto', sans-serif;
    margin-top: 0.2rem;
    align-self: start;
    grid-column: 2/3;
    grid-row: 2/3;
  }
`;

export const ReadinessModalHeader = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
  padding: 0 20px 20px;
  align-items: center;
  margin-bottom: 1.5rem;

  button.closeModal {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    background: none;
    color: ${({ theme }: {theme: any}) => theme.black};
    cursor: pointer;

    &:hover {
      color: ${({ theme }: {theme: any}) => theme.themePrimary};
    }
  }

  h1 {
    font: 700 1.5rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    opacity: 0.1;
    background: ${({ theme }: {theme: any}) => theme.black};
  }
`;

export const ReadinessModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  position: relative;

  a.contentLink {
    position: absolute;
    top: 0;
    right: 1rem;
    margin-left: auto;
    color: ${({ theme }: {theme: any}) => theme.themePrimary};
    cursor: pointer;
  }

  p {
    font: 400 1rem/1.1rem 'Segoe UI', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
    padding: 0 40px 0 20px;
  }

  .videoContainer {
    width: 80%;
    margin: 0 auto;

    .iframeWrapper {
      position: relative;
      width: 100%;
      padding-bottom: 56.25%;
      overflow: hidden;
      border-radius: 1rem;

      .thumbnail {
        display: flex;
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
        top: 0;
        left: 0;
      }

      iframe {
        display: none;
        border: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      &.loaded {
        iframe {
          display: flex;
        }
        .thumbnail {
          display: none;
        }
      }
    }
  }

  iframe {
    border: none;
  }
`;
